import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import '../SelectedHistory.scss';
import { tableBetHistoryStore, useTranslation } from '@pascal/pascal-core';
import { CARDS_TYPE } from '../../../enums/cardTypes';
import {
  BETS_NAMES_BY_GROUP_TYPES,
  BETS_NAMES_BY_MARKET_TYPE,
  BOARD_CARD_GROUP_TYPES,
  BOARD_CARD_WIN_TYPE_NAMES,
  ROUND_PHASE_KEYS_BY_TYPES,
  ROUND_PHASE_TYPES,
  ROUND_PHASE_TYPES_NAMES,
  TABLE_BOX_TYPES,
  WIN_COMBINATIONS_NAMES,
} from '../../../enums/betTypesEnum';

const BETS_ROW_NAMES = ['BET_TYPE', 'BET', 'ODD', 'WIN'];

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { data: thirdStepData } = thirdStep;
  const [activePhase, setActivePhase] = useState(null);
  const t = useTranslation();

  const cardsByBox = useMemo(() => {
    return thirdStepData.boxCards.reduce((acc, cur) => {
      if (acc[cur.boxIndex]) {
        acc[cur.boxIndex].push(cur);
      } else {
        acc[cur.boxIndex] = [cur];
      }
      return acc;
    }, {});
  }, [thirdStepData]);

  useEffect(() => {
    if (thirdStepData.bets && activePhase === null) {
      let isFirst = false;
      Object.keys(ROUND_PHASE_TYPES).forEach((item) => {
        if (!activePhase && thirdStepData.bets[item] && !isFirst) {
          isFirst = true;
          setActivePhase(ROUND_PHASE_TYPES[item]);
        }
      });
    }
  }, [thirdStepData, activePhase, setActivePhase]);

  const handleChangeActiveBetPhase = useCallback(
    (value) => {
      if (thirdStepData.bets[ROUND_PHASE_KEYS_BY_TYPES[value]]) {
        setActivePhase(value);
      }
    },
    [setActivePhase, thirdStepData]
  );

  const activeBetByPhase = useMemo(() => {
    return thirdStepData.bets[ROUND_PHASE_KEYS_BY_TYPES[activePhase]] || null;
  }, [thirdStepData, activePhase]);

  const UserBetRow = useCallback(
    ({ groupType, marketType, amount, odd, winAmount }) => {
      return (
        <div className='r-details-bets-content-row'>
          <div className='r-details-bets-content-cell'>
            {BOARD_CARD_GROUP_TYPES.includes(groupType) ? (
              <p className='r-details-bets-content-cell-txt'>
                {t(BETS_NAMES_BY_GROUP_TYPES[groupType])} {t(BETS_NAMES_BY_MARKET_TYPE[marketType])}
              </p>
            ) : (
              <p className='r-details-bets-content-cell-txt'>
                {t(BETS_NAMES_BY_MARKET_TYPE[marketType])}
              </p>
            )}
          </div>
          <div className='r-details-bets-content-cell'>
            <p className='r-details-bets-content-cell-txt'>
              {amount} {thirdStepData.freeBetId ? `(${t('FREE_BET')})` : ''}
            </p>
          </div>
          <div className='r-details-bets-content-cell'>
            <p className='r-details-bets-content-cell-txt'>{odd}</p>
          </div>
          <div className='r-details-bets-content-cell'>
            <p className='r-details-bets-content-cell-txt'>{winAmount}</p>
          </div>
        </div>
      );
    },
    [thirdStepData, t]
  );

  return (
    <div className='tb-game-history-wrapper'>
      <div className='cards-details-wrapper'>
        <div className='cards-details-row'>
          {thirdStepData.boardCards.map(({ card, index }) => (
            //   ADD class " win "
            <div key={index} className={`details-card card-deck-1 ${CARDS_TYPE[card]}`} />
          ))}
        </div>
        <div className='cards-details-row cards-details-row-bottom'>
          {TABLE_BOX_TYPES.map((item, i) => (
            <div key={item} className='cards-details-cell'>
              <div className='cards-details-cell-top'>
                {cardsByBox[i + 1].map(({ card, index }) => (
                  <div
                    key={index}
                    className={`details-cell-card card-deck-1 ${CARDS_TYPE[card]}`}
                  />
                ))}
              </div>
              {/* ADD class " win " */}
              <div
                className={`cards-details-cell-bottom ${
                  cardsByBox[i + 1][0].isWin ||
                  cardsByBox[i + 1][1].isWin ||
                  !thirdStepData.boxCards.find((elem) => elem.isWin)
                    ? 'win'
                    : ''
                }`}
              >
                <div className='details-cell-num'>{i + 1}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='round-details-holder'>
        <p className='r-details-title'>{t('RESULT')}</p>
        <div className='r-details-result-holder'>
          <div className='r-details-result-row'>
            <div className='r-details-result-cell'>
              <p className='r-details-result-txt'>{t('COMBINATIONS')}</p>
            </div>
            <div className='r-details-result-cell'>
              <p className='r-details-result-txt'>
                {t(WIN_COMBINATIONS_NAMES[thirdStepData.winningCombination])}
              </p>
            </div>
          </div>
          <div className='r-details-result-row'>
            <div className='r-details-result-cell'>
              <p className='r-details-result-txt'>{t('ADDITIONAL_BETS')}</p>
            </div>
            <div className='r-details-result-cell'>
              <p className='r-details-result-txt'>
                {thirdStepData.boardCardWinTypes.map(
                  (item, i, arr) =>
                    `${t(BOARD_CARD_WIN_TYPE_NAMES[item])}${i === arr.length - 1 ? '' : ','} `
                )}
              </p>
            </div>
          </div>
        </div>
        <p className='r-details-title'>{t('MY_BETS')}</p>
        <div className='r-details-bets-holder'>
          <div className='r-details-bets-tabs'>
            {Object.keys(ROUND_PHASE_TYPES_NAMES).map((value) => (
              <div
                key={value}
                onClick={() => handleChangeActiveBetPhase(value)}
                className={`r-details-bets-tab ${
                  thirdStepData.bets[ROUND_PHASE_KEYS_BY_TYPES[value]] ? '' : 'disabled'
                } ${+activePhase === +value ? 'active' : ''}`}
              >
                <p className='r-details-bets-tab-txt'>{t(ROUND_PHASE_TYPES_NAMES[value])}</p>
              </div>
            ))}
          </div>

          {activeBetByPhase && (
            <div className='r-details-bets-content'>
              <div className='r-details-bets-content-header-row'>
                {BETS_ROW_NAMES.map((name) => (
                  <div key={name} className='r-details-bets-content-header-cell'>
                    <p className='r-details-bets-content-header-cell-txt'>{t(name)}</p>
                  </div>
                ))}
              </div>
              {activeBetByPhase.map(({ id, amount, odd, winAmount, additionalParams }) => {
                if (additionalParams?.additionalBets?.length) {
                  return (
                    <Fragment key={id}>
                      {additionalParams?.additionalBets.map((additionalBet) => (
                        <UserBetRow
                          key={`${additionalBet.groupType}_${additionalBet.marketType}_${id}`}
                          odd={additionalBet.odd}
                          amount={additionalBet.amount}
                          winAmount={additionalBet.winAmount}
                          groupType={additionalBet.groupType}
                          marketType={additionalBet.marketType}
                        />
                      ))}
                    </Fragment>
                  );
                }
                return (
                  <UserBetRow
                    key={id}
                    odd={odd}
                    amount={amount}
                    winAmount={winAmount}
                    marketType={additionalParams?.marketType}
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
